import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import type { Technology } from '../../domain/technology';
import { TechnologiesService } from '../../services/technologies';
import { useCompanyQuery } from '../company/useCompanyQuery';

import { technologiesApi } from './api';

export const useTechnologiesQuery = (): UseQueryResult<Technology[]> => {
  const { isOpen } = useAppState();
  const { domain: companyDomain = '' } = useCompanyQuery().data || {};
  const { removeDuplicateTechnologies, sortTechnologies } = TechnologiesService;

  const query = useQuery({
    queryKey: ['technographics', companyDomain],
    queryFn: async ({ signal }) => {
      const technologies = await technologiesApi.getTechnologies(companyDomain, signal);
      const result = sortTechnologies(removeDuplicateTechnologies(technologies));
      return result;
    },
    enabled: isOpen && !!companyDomain,
    retry: false,
    refetchInterval: false,
  });

  return query;
};
